'use strict';

global.utl = require('../utils.js');
global.offset = 0;

var initialLimit = 16;
var limit   = 8;
var loaded = false;
var finish = false;
var init = true;

var self = module.exports = {
  init: function () {
    if (init == true) {
      self.loadMore(global.offset, initialLimit);
      self.existMore(global.offset + initialLimit, 1);
    }

    $(window).scroll(function() {
      var end = $("#load-more").offset().top;
      var viewEnd = $(window).scrollTop() + $(window).height();
      var distance = end - viewEnd;

      if (distance < 100 && loaded == false && finish == false && init == false) {
        self.loaded();
        self.loadMore(global.offset, limit);
        self.existMore(global.offset + limit, 1);
      }
    });
  },

  loaded: function() {
    loaded = true;
  },

  loadMore: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgetpreview/case_history/' + offset + ',' + limit + '/sortablePosition,desc'
    }).done(function(data) {
      $('#load-more').removeClass('hide');

      (function(data, offset) {

        var template = $('#hashtag-template').html();
        var wrapper = $('.landing-wrapper');
        global.offset += data.length;

        mustache.parse(template);
        var rendered = mustache.render(template, {'widgets': data});

        wrapper.append(rendered);

        var moodboard = wrapper.find('.landing-moodboard');

        //@TODO Refactor with a simple forEach. Using jQuery each is very slow!!!
        $.each(moodboard, function(key, group) {
          var modules = $(group).find('.hashtag-module');

          $.each(modules, function(key, element) {
            $(element).addClass('hashtag-module_position_' + key);

            if (key == 6 || key == 7 || key == 14 || key == 15 ) {
              $(element).addClass('hashtag-module_ratio_rectangular');
            }
          });
        });

        $(document).foundation();
        loaded = false;
        init = false;

      })(data, offset);
    });
  },

  existMore: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgetpreview/case_history/' + offset + ',' + limit + '/sortablePosition,desc'
    }).done(function(data) {
      (function(data, offset) {
        if (data.length > 0) {
          $('#load-more').removeClass('hide');
        } else {
            finish = true;
            $( document ).ajaxStop(function() {
                $('#load-more').addClass('hide');
            });
        }
      })(data, offset);
    });
  }
};

self.init();
